// extracted by mini-css-extract-plugin
module.exports =  {"policyLinkContainer":"PoliciesTable_policyLinkContainer__M2+eg","currencyContainer":"PoliciesTable_currencyContainer__e1Qro"};